const initialState = {
    activeFeature: null,
    searchBarVisible: false,
    searchedLocation: null,
    activePage: "map",
    activeFilters: [],
    basemap: "ROADMAP",
    activeProject: undefined,
    viewingHub: undefined,
    mapType: "electorates",
    internal: false,
    zoomToNsw: Date.now(),
};
export default (state = initialState, action) => {
    switch (action.type) {
        case "ACTIVE_FEATURE:SET":
            return {
                ...state,
                searchedLocation: null,
                activeFeature: action.payload,
            };
        case "SEARCH_BAR_VISIBLE:SET":
            return { ...state, searchBarVisible: action.payload };
        case "SEARCHED_LOCATION:SET":
            return { ...state, searchedLocation: action.payload };
        case "ACTIVE_PROJECT:SET":
            return { ...state, activeProject: action.payload };
        case "ACTIVE_FILTER:SET": {
            const { activeFilters } = state;
            let newFilters = [];
            // Remove if its in there
            if (activeFilters.includes(action.payload)) {
                newFilters = activeFilters.filter(d => d !== action.payload);
            } else {
                newFilters = activeFilters.concat(action.payload);
            }
            return { ...state, activeFilters: newFilters };
        }
        case "ACTIVE_PAGE:SET": {
            return { ...state, activePage: action.payload };
        }
        case "MAP_TYPE:SET": {
            return { ...state, mapType: action.payload };
        }
        case "MAP:SET_BASEMAP": {
            return { ...state, basemap: action.payload };
        }
        case "ZOOM_TO_NSW": {
            return { ...state, zoomToNsw: action.payload };
        }

        default:
            return state;
    }
};

export const selectActiveFeature = s => s.activeFeature;
export const selectSearchBarVisible = s => s.searchBarVisible;
export const selectSearchedLocation = s => s.searchedLocation;
export const selectActiveProject = s => s.activeProject;
export const selectActiveFilters = s => s.activeFilters;
export const selectActivePage = s => s.activePage;
export const selectMapType = s => s.mapType;
export const selectViewingHub = s => s.viewingHub;
export const selectIsInternal = s => s.internal;
export const selectBasemap = s => s.basemap;
export const selectZoomToNsw = s => s.zoomToNsw;



// WEBPACK FOOTER //
// ./src/reducers/ui.js